function lockBodyScroll() {
    document.body.classList.add('lightbox-open');
}

function unlockBodyScroll() {
    document.body.classList.remove('lightbox-open');
}

document.addEventListener("DOMContentLoaded", function () {
	// Create a reusable dialog element
	let dialog = document.createElement("dialog");
	dialog.classList.add("bds-lightbox-dialog");
	dialog.setAttribute("role", "dialog");
	dialog.setAttribute("aria-modal", "true");
	dialog.setAttribute("tabindex", "-1");
	dialog.setAttribute("aria-label", "Lightbox dialog");
	// Overlay div removed; using dialog::backdrop for overlay
	document.body.appendChild(dialog);

	// Add a close button
	let closeBtn = document.createElement("button");
	closeBtn.textContent = "";
	closeBtn.className = "bds-lightbox-close";
	closeBtn.setAttribute("aria-label", "Close dialog");
	dialog.appendChild(closeBtn); // Always append to dialog, not content

	let lastActiveElement = null;

	// Helper to set dialog type class
	function setDialogTypeClass(type) {
		const types = ["image", "video", "pdf", "youtube", "iframe", "dialog"];
		types.forEach((t) =>
			dialog.classList.remove(`bds-lightbox-dialog--${t}`),
		);
		if (type && types.includes(type)) {
			dialog.classList.add(`bds-lightbox-dialog--${type}`);
		}
	}

	// Helper to extract width/height from classList (e.g., width-600, height-400)
	function getCustomDimensions(classList) {
		let width = classList.find((cls) => cls.startsWith("width-"));
		let height = classList.find((cls) => cls.startsWith("height-"));
		if (width) {
			width = width.replace("width-", "");
			if (/^\d+$/.test(width)) width += "px";
		}
		if (height) {
			height = height.replace("height-", "");
			if (/^\d+$/.test(height)) height += "px";
		}
		return {
			width: width || null,
			height: height || null,
		};
	}

	// Accessible description helper using theme strings
	function setDialogDescription(type) {
		// Remove any previous description
		const prevDesc = dialog.querySelector("#dialog-content-desc");
		if (prevDesc) prevDesc.remove();
		dialog.removeAttribute("aria-describedby");

		// Get theme strings for lightboxes
		const themeStrings =
			window.bds_theme &&
			window.bds_theme.strings &&
			window.bds_theme.strings.lightboxes
				? window.bds_theme.strings.lightboxes
				: {};

		let descText = themeStrings[type] || "";
		if (descText) {
			const desc = document.createElement("div");
			desc.id = "dialog-content-desc";
			desc.style.position = "absolute";
			desc.style.left = "-9999px";
			desc.textContent = descText;
			dialog.appendChild(desc);
			dialog.setAttribute("aria-describedby", "dialog-content-desc");
		}
	}

	function trapFocus(e) {
		const focusableEls = dialog.querySelectorAll(
			'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])',
		);
		const firstFocusableEl = focusableEls[0];
		const lastFocusableEl = focusableEls[focusableEls.length - 1];

		if (e.key === "Tab") {
			if (e.shiftKey) {
				// shift + tab
				if (document.activeElement === firstFocusableEl) {
					e.preventDefault();
					lastFocusableEl.focus();
				}
			} else {
				// tab
				if (document.activeElement === lastFocusableEl) {
					e.preventDefault();
					firstFocusableEl.focus();
				}
			}
		}
	}

	closeBtn.addEventListener("click", () => dialog.close());

	dialog.addEventListener("click", function (e) {
		if (e.target === dialog) {
			dialog.close();
		}
	});

	let currentLightboxTarget = null;
	dialog.addEventListener("close", () => {
		unlockBodyScroll();
		// Hide the lightbox target if needed
		if (currentLightboxTarget && currentLightboxTarget.classList && currentLightboxTarget.classList.contains("lightbox-target")) {
			currentLightboxTarget.style.display = "none";
			currentLightboxTarget.setAttribute("aria-hidden", "true");
			document.body.appendChild(currentLightboxTarget);
			currentLightboxTarget = null;
		}
		// Remove all content except the close button
		[...dialog.children].forEach((child) => {
			dialog.removeChild(child);
		});
		// Remove aria-describedby for accessibility reset
		dialog.removeAttribute("aria-describedby");
		// Remove type class
		setDialogTypeClass(null);
		// Restore focus to last active element
		if (lastActiveElement) lastActiveElement.focus();
	});

	dialog.addEventListener("keydown", function (e) {
		if (e.key === "Escape") dialog.close();
		trapFocus(e);
	});

	// Lightbox for button links (supports ID or file)
	document
		.querySelectorAll(".lightbox > a, a.lightbox")
		.forEach(function (lightbox) {
			const url = lightbox.getAttribute("href");
			const hash = new URL(url, window.location.href).hash;
			const content = hash ? document.querySelector(hash) : null;

			lightbox.addEventListener("click", function (e) {
				e.preventDefault();
				lastActiveElement = lightbox;

				[...dialog.children].forEach((child) => {
					dialog.removeChild(child);
				});

				let fileType = "dialog"; // Default to "dialog" for button-triggered

				if (content) {
									if (content.classList.contains("lightbox-target")) {
										content.style.display = "block";
									}
									content.setAttribute("aria-hidden", "false");
									currentLightboxTarget = content;
									const wrapper = document.createElement("div");
					wrapper.className =
						"bds-lightbox-content bds-lightbox-content--dialog";
					wrapper.appendChild(content);
					if (!dialog.contains(closeBtn)) dialog.appendChild(closeBtn);
					dialog.appendChild(wrapper);

					// Optionally, guess type from content tagName if you want
					if (content.tagName === "IMG") fileType = "image";
					else if (content.tagName === "VIDEO") fileType = "video";
					else if (content.tagName === "IFRAME") fileType = "iframe";

					dialog.showModal();
					document.body.classList.add("lightbox-open");
					closeBtn.focus();

										dialog.addEventListener(
						"close",
						function () {
							if (content.classList.contains("lightbox-target")) {
								content.style.display = "none";
							}
							content.setAttribute("aria-hidden", "true");
							document.body.appendChild(content);
						},
						{ once: true },
					);
				} else {
					if (/\.(jpe?g|png|gif|webp|svg)$/i.test(url)) {
						fileType = "image";
					} else if (/\.(mp4|webm|ogg)$/i.test(url)) {
						fileType = "video";
					} else if (/\.(pdf)$/i.test(url)) {
						fileType = "pdf";
					} else if (
						/^https?:\/\/(www\.)?(youtube\.com|youtu\.be)/i.test(
							url,
						)
					) {
						fileType = "youtube";
					} else {
						fileType = "iframe";
					}

					const wrapper = document.createElement("div");
					wrapper.className = `bds-lightbox-content bds-lightbox-content--${fileType}`;

					let el;
					const parent = lightbox.closest(
						".wp-block-button.lightbox",
					);
					const classList = parent
						? Array.from(parent.classList)
						: [];
					const { width: customWidth, height: customHeight } =
						getCustomDimensions(classList);
					switch (fileType) {
						case "image":
							el = document.createElement("img");
							el.src = url;
							el.alt = lightbox.textContent || "Image preview";
							el.style.maxWidth = "90vw";
							el.style.maxHeight = "80vh";
							break;
						case "video":
							el = document.createElement("video");
							el.src = url;
							el.controls = true;
							el.autoplay = true;
							break;
						case "pdf":
							el = document.createElement("iframe");
							el.src = url;
							el.type = "application/pdf";
							el.style.width = customWidth || "90vw";
							el.style.height = customHeight || "80vh";
							el.setAttribute("title", "PDF preview");
							break;
						case "youtube":
							el = document.createElement("iframe");
							const ytId = url.match(
								/(?:v=|\/)([0-9A-Za-z_-]{11})/,
							);
							el.src = ytId
								? `https://www.youtube.com/embed/${ytId[1]}`
								: url;
							el.allow =
								"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
							el.allowFullscreen = true;
							el.style.width = customWidth || "90vw";
							el.style.height = customHeight || "60vh";
							el.setAttribute("title", "YouTube video");
							break;
						default:
							el = document.createElement("iframe");
							el.src = url;
							el.style.width = customWidth || "90vw";
							el.style.height = customHeight || "80vh";
							el.setAttribute("title", "File preview");
					}
					if (!dialog.contains(closeBtn)) dialog.appendChild(closeBtn);
					dialog.appendChild(wrapper);
					wrapper.appendChild(el);
					dialog.showModal();
					closeBtn.focus();
				}

				setDialogTypeClass(fileType);
				setDialogDescription(fileType);
			});
		});

	// Lightbox for gallery images with cycling
	document
		.querySelectorAll(".wp-block-gallery a")
		.forEach(function (galleryLink) {
			galleryLink.addEventListener("click", function (e) {
				e.preventDefault();
				lastActiveElement = galleryLink;

				// Get all gallery links in the same gallery
				const gallery = galleryLink.closest(".wp-block-gallery");
				const links = Array.from(gallery.querySelectorAll("a"));
				let currentIndex = links.indexOf(galleryLink);

				function showImage(index) {
					[...dialog.children].forEach((child) => {
						dialog.removeChild(child);
					});

					const img = document.createElement("img");
					img.src = links[index].href;
					img.alt =
						links[index].querySelector("img")?.alt ||
						"Gallery image";
					img.style.maxWidth = "90vw";
					img.style.maxHeight = "80vh";
					const wrapper = document.createElement("div");
					wrapper.className =
						"bds-lightbox-content bds-lightbox-content--image";
					wrapper.appendChild(img);

					const figure = links[index].closest("figure");
					const figcaption = figure
						? figure.querySelector("figcaption")
						: null;

					if (figcaption) {
						const caption = figcaption.cloneNode(true);
						caption.classList.add("bds-lightbox-caption");
						wrapper.appendChild(caption);
					}

					setDialogDescription("image");

					// Prev button
					if (index > 0) {
						let prevBtn = document.createElement("button");
						prevBtn.setAttribute("aria-label", "Previous");
						prevBtn.className = "bds-lightbox-prev";
						prevBtn.onclick = () => {
							currentIndex = currentIndex - 1;
							showImage(currentIndex);
						};
						wrapper.appendChild(prevBtn);
					}
					wrapper.appendChild(closeBtn);
					dialog.appendChild(wrapper);

					// Next button
					if (index < links.length - 1) {
						let nextBtn = document.createElement("button");
						nextBtn.setAttribute("aria-label", "Next");
						nextBtn.className = "bds-lightbox-next";
						nextBtn.onclick = () => {
							currentIndex = currentIndex + 1;
							showImage(currentIndex);
						};
						wrapper.appendChild(nextBtn);
					}
				}

				showImage(currentIndex);
									dialog.showModal();
									document.body.classList.add("lightbox-open");
									closeBtn.focus();

									// Keyboard navigation
				dialog.onkeydown = function (ev) {
					if (ev.key === "ArrowLeft" && currentIndex > 0) {
						currentIndex--;
						showImage(currentIndex);
					} else if (
						ev.key === "ArrowRight" &&
						currentIndex < links.length - 1
					) {
						currentIndex++;
						showImage(currentIndex);
					}
				};
			});
		});

	// Lightbox for grid images with cycling
	document
		.querySelectorAll(".wp-block-group.is-layout-grid .wp-block-image a")
		.forEach(function (gridLink) {
			gridLink.addEventListener("click", function (e) {
				e.preventDefault();
				lastActiveElement = gridLink;

				// Get all grid image links in the same grid container
				const grid = gridLink.closest(".wp-block-group.is-layout-grid");
				const links = Array.from(
					grid.querySelectorAll(".wp-block-image a"),
				);
				let currentIndex = links.indexOf(gridLink);

				function showImage(index) {
					// Remove previous images/descriptions/buttons
					[...dialog.children].forEach((child) => {
						if (child !== closeBtn) dialog.removeChild(child);
					});

					const img = document.createElement("img");
					img.src = links[index].href;
					img.alt =
						links[index].querySelector("img")?.alt || "Grid image";
					img.style.maxWidth = "90vw";
					img.style.maxHeight = "80vh";
					const wrapper = document.createElement("div");
					wrapper.className =
						"bds-lightbox-content bds-lightbox-content--image";
					wrapper.appendChild(img);

					const figure = links[index].closest("figure");
					const figcaption = figure
						? figure.querySelector("figcaption")
						: null;

					if (figcaption) {
						const caption = figcaption.cloneNode(true);
						caption.classList.add("bds-lightbox-caption");
						wrapper.appendChild(caption);
					}

					setDialogDescription("image");

					// Prev button
					if (index > 0) {
						let prevBtn = document.createElement("button");
						prevBtn.setAttribute("aria-label", "Previous");
						prevBtn.className = "bds-lightbox-prev";
						prevBtn.onclick = () => {
							currentIndex = currentIndex - 1;
							showImage(currentIndex);
						};
						wrapper.appendChild(prevBtn);
					}

					// Next button
					if (index < links.length - 1) {
						let nextBtn = document.createElement("button");
						nextBtn.setAttribute("aria-label", "Next");
						nextBtn.className = "bds-lightbox-next";
						nextBtn.onclick = () => {
							currentIndex = currentIndex + 1;
							showImage(currentIndex);
						};
						wrapper.appendChild(nextBtn);
					}
				}

				showImage(currentIndex);

				dialog.showModal();
				closeBtn.focus();

				// Keyboard navigation
				dialog.onkeydown = function (ev) {
					if (ev.key === "ArrowLeft" && currentIndex > 0) {
						currentIndex--;
						showImage(currentIndex);
					} else if (
						ev.key === "ArrowRight" &&
						currentIndex < links.length - 1
					) {
						currentIndex++;
						showImage(currentIndex);
					}
				};
			});
		});

	// Auto-open lightbox if URL has a hash matching a lightbox-target
	if (window.location.hash) {
		const hash = window.location.hash;
		const target = document.querySelector(hash + ".lightbox-target");
		if (target) {
			// Find a trigger link if you want to simulate a click, or open directly:
			// Option 1: Open directly (re-using your dialog logic)
			target.style.display = "block";
			target.setAttribute("aria-hidden", "false");

			let dialog = document.querySelector("dialog.bds-lightbox-dialog");
			if (!dialog) return;

			// Remove previous content
			[...dialog.children].forEach((child) => dialog.removeChild(child));

			// Create wrapper and close button
			let wrapper = document.createElement("div");
			wrapper.className =
				"bds-lightbox-content bds-lightbox-content--dialog";
			let closeBtn = document.createElement("button");
			closeBtn.textContent = "";
			closeBtn.className = "bds-lightbox-close";
			closeBtn.setAttribute("aria-label", "Close dialog");
			wrapper.appendChild(target);
			wrapper.appendChild(closeBtn);
			dialog.appendChild(wrapper);

			dialog.showModal();
			document.body.classList.add("lightbox-open");
			closeBtn.focus();

						closeBtn.addEventListener("click", () => dialog.close());
			dialog.addEventListener(
				"close",
				function () {
					if (target.classList.contains("lightbox-target")) {
						target.style.display = "none";
					}
					target.setAttribute("aria-hidden", "true");
					document.body.appendChild(target);
				},
				{ once: true },
			);
		}
	}
});
